import { REJECT_RECHARGE_REQUEST, REJECT_RECHARGE_SUCCESS, REJECT_RECHARGE_FAILURE, REJECT_RECHARGE_RESET, } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const rejectRechargeReducer = (state = initialState, action) => {
    switch (action.type) {
        case REJECT_RECHARGE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case REJECT_RECHARGE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case REJECT_RECHARGE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case REJECT_RECHARGE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default rejectRechargeReducer;
